









































































import Vue from "vue";
import Component from "vue-class-component";
import vue2Dropzone from "vue2-dropzone";
import { dropzonePreviewTemplate } from "@/components/core/dropzone/dropzone-preview";
import { graphqlClient } from "@/utils/graphql";
import { UPLOAD_FILE_TO_REPORT_MUTATION } from "@/models/mutations/UploadFileToReportMutation";
import { UploadFileToReportVariables, UploadFileToReport } from "@/models/mutations/types/UploadFileToReport";
import { ReportStep, UploadFileResponse } from "@/models/graphql-global-types";
import LoadingButton from "@/components/core/controls/loading-button.component.vue";
import Checkbox from "@/components/core/controls/checkbox.vue";
import { NewReportStore } from "@/store/NewReportStore";
import { Watch } from "vue-property-decorator";

@Component({
  props: {
    showDialog: Boolean,
    report: Object,
    reportSheet: Object,
    refetch: Function
  },
  components: {
    vueDropzone: vue2Dropzone,
    LoadingButton,
    Checkbox
  }
})
export default class ReportFileUploadDialog extends Vue {
  private refetch!: () => void;
  private selectedFile: File | null = null;
  private fileName: string = "";
  private isUploading: boolean = false;
  private report: any;
  private reportSheet: any;
  private description: string = "";
  private characteristic: any = null;
  private isMc: boolean = false;
  private acceptedFileTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];
  private getDropzoneOptions() {
    return {
      url: "url",
      maxFiles: 1,
      thumbnailWidth: 50,
      accept: this.acceptFile,
      createImageThumbnails: false,
      previewTemplate: dropzonePreviewTemplate()
    };
  }

  private mounted() {
    $("#reportFileUploadModal").on("show.bs.modal", () => {
      this.closeDialog();
    });
  }

  private closeDialog() {
    // @ts-ignore
    $("#reportFileUploadModal").modal("hide");
    this.clearFile();
    this.reset();
  }

  private reset() {
    this.description = "";
    this.fileName = "";
    this.characteristic = null;
    this.isMc = false;
  }

  private clearFile() {
    this.clearDropZone(this.selectedFile);
    this.selectedFile = null;
    this.reset();
  }
  private acceptFile(file) {
    if (!this.fileName) {
      this.fileName = this.getFileNameWithoutExtension(file.name);
    }
    this.clearDropZone(this.selectedFile);
    if (!this.acceptedFileTypes.includes(file.type)) {
      this.$notify({
        title: this.$t("general.error.error") as string,
        text: this.$t("report.upload.wrong_file_type") as string,
        type: "error"
      });
      this.clearDropZone(file);
      this.selectedFile = null;
    } else {
      this.selectedFile = file;
    }

    if (this.getExtension(file.name) !== "pdf") {
      this.isMc = false;
    }
  }
  private clearDropZone(file) {
    const dropzone = this.$refs.myVueDropzone as any;
    if (dropzone && file) {
      dropzone.removeFile(file);
    }
  }

  private showError() {
    this.$notify({
      title: this.$t("general.error.error") as string,
      text: this.$t("file_upload.saving.error") as string,
      type: "error"
    });
  }

  private getFileNameWithoutExtension(name) {
    return name ? name.substring(0, name.lastIndexOf(".")) : undefined;
  }

  private getExtension(name) {
    return name ? name.substring(name.lastIndexOf("."), name.length) : undefined;
  }

  get characteristicOptions() {
    return this.reportSheet.characteristicGroups.flatMap(cg =>
      cg.characteristics.flatMap(characteristic => {
        const name = characteristic.translations[this.$i18n.locale] || "";
        const label = `${characteristic.shortcut} - ${name}`;
        return { ...characteristic, label };
      })
    );
  }

  private async uploadFile() {
    const valid = await this.$validator.validateAll();
    if (valid && this.selectedFile && this.fileName) {
      const extension = this.getExtension(this.selectedFile.name);
      this.isUploading = true;
      const fullFileName = `${this.fileName}${extension}`;

      try {
        const result = await graphqlClient.mutate<UploadFileToReport, UploadFileToReportVariables>({
          mutation: UPLOAD_FILE_TO_REPORT_MUTATION,
          variables: {
            file: this.selectedFile,
            reportId: this.report.id,
            fileName: fullFileName,
            sheetId: this.reportSheet ? this.reportSheet.id : null,
            description: this.description,
            characteristicsId: this.characteristic ? this.characteristic.id : null,
            mc: this.isMc
          }
        });
        console.log(this.report.step);
        if (this.report.step === ReportStep.CREATED) {
          await NewReportStore.changeStatus({ report: { id: this.report.id }, lane: ReportStep.IN_PROGRESS });
        }
        this.isUploading = false;
        if (result && result.data && result.data.uploadFileToReport === UploadFileResponse.SUCCESS) {
          this.refetch();
          this.$notify({
            title: this.$t("general.success") as string,
            text: this.$t("file_upload.saving.success") as string,
            type: "success"
          });
          this.closeDialog();
        } else if (result && result.data && result.data.uploadFileToReport === UploadFileResponse.FILE_EXISTS) {
          this.$notify({
            title: this.$t("general.error.error") as string,
            text: this.$t("file_upload.saving.file_exists") as string,
            type: "warn"
          });
        } else {
          this.showError();
        }
      } catch (error) {
        console.error(error);
        this.isUploading = false;
        this.showError();
      }
    }
  }

  @Watch("isMc")
  public watchIsMc() {
    if (this.isMc) {
      this.characteristic = null;
    }
  }

  @Watch("characteristic", { deep: true })
  public watchCharacteristic() {
    if (this.characteristic) {
      this.isMc = false;
    }
  }
}
